'use client'

import React from "react";
import { motion } from 'framer-motion';
import { Typography, Container } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from '@mui/lab';

export const PortraitSection = ({ data }) => {
    return (
        <motion.section
            className="section-large"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom>
                        Portrait
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                <Container maxWidth="full" className="no-padding">
                    <Timeline className="no-padding">
                        {data.map(item => (
                            <TimelineItem key={item.id}>
                                <TimelineOppositeContent color="text.secondary">
                                    {item.bis === item.von ?
                                        item.von :
                                        `${item.von} - ${item.bis ? item.bis : "Heute"}`}
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot />
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent color="text.secondary">{item.beschreibung}</TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>
                </Container>
            </div>
        </motion.section>
    );
};
